import { View, Model } from 'backbone';
import listService from 'ListService';
import eventBus from '../../service/EventBus.js';
import constants from '../../constants/Constants.js';
import mobileConstants from '../../mobile/commons/MobileFormsConstants.js';
import mobileListService from '../../service/mobile/MobileListService.js';
import SimpleConfirmModalView from '../common-views/SimpleConfirmModalView.js';
import template from '../../../templates/mobile/mobile-columns.ejs';
import badgesTemplate from '../../../templates/mobile/mobile-column-badges.ejs';
import NotificationService from 'NotificationService.js'
import pageSyncService from "../../service/PageSyncService.js";
import $ from 'jquery';

class MobileDesignerColumnView extends View {
    initialize(opts) {
        this.options = opts || {};
      
        this.listenTo(eventBus, constants.EV_CURRENT_COLUMN_VIEW_UPDATED, this.updateColumnView );
        this.listenTo(eventBus, 'createDraggableSections', this.createDraggableSections );
        this.listenTo(eventBus, constants.EV_RESET_COLUMN_PER_PAGE, this.resetColumn );
        this.listenTo(eventBus, mobileConstants.CREATE_DRAGGABLE_SECTION, this.createDraggableSections );
        this.listenTo(eventBus, mobileConstants.CREATE_DRAGGABLE_MOBILE_CONTROLS, this.createDraggableMobileControls );
        
        return this;
    }

    static resetColumnTwo() {
        listService.deleteMobileColumnsByOrder(listService.currentPageId, mobileConstants.FIRST_COLUMN_ORDER);
        listService.deleteMobileColumnsByOrder(listService.currentPageId, mobileConstants.SECOND_COLUMN_ORDER);
        pageSyncService.renderMobileCurrentPageView();
    }

    resetColumn(){
        const pageID = listService.currentPageId;
        const pageName = listService.getPage(pageID).model.get('pageTitle');
        let text = `Reset will remove all sections from the 2 column settings on 
                   ${pageName} and restore ${pageName} to the default (1 column setting). 
                   You cannot undo a reset. Are you sure you would like to reset Column 2 for ${pageName}?`;

        let simpleModal = new SimpleConfirmModalView ({
            model: new Model({subtitle:'Reset column per page',
            confirmationText: text,
            height: 200,
            width: 400})
        });

        const self = this;
        simpleModal.render().then((result)=>{
            if (result === 'Ok') {
                self.resetColumnTwo();
                self.updateColumnView();
            }
        }).catch((err)=> {
            console.log('Error Showing Reset Per Page Confirmation Message', err);
            NotificationService.error('Error Showing Reset Per Page Confirmation Message' + err.MESSAGE);
        });       
    }
    
    updateColumnView(){
        let layout1 = $(`#${constants.ONE_COLUMN_LAYOUT}`);
        let layout2 = $(`#${constants.TWO_COLUMN_LAYOUT}`);
       
        if (mobileListService.mobileCurrentColumnView === constants.ONE_COLUMN_VIEW_DROPDOWN_TEXT) {
            layout1.css('display', 'block');
            layout2.css('display', 'none');
            this.sectionsLayoutRender(mobileConstants.CURRENT_COLUMN_ORDER);
        } else {
            layout1.css('display', 'block');
            layout2.css('display', 'block');
            this.sectionsLayoutRender(mobileConstants.SECOND_COLUMN_ORDER);
            let _display = $('#column2-content').children('.pf-section-control').length === 0 ? 'inline-block' : 'none';
            $('#columnsPlaceholder').css('display',  _display);
        }
    }

    setUpWidgets(){
        $('ul.views-options a.layout-switch').removeClass('active');
        $('#mobileFormsView a').addClass('active');
    }

    isHiddenSection(controlSection) {
        return controlSection.model.isEmpty() || controlSection.model.allControlsHiddenState();
    }

    getLayoutColumnByOrder(order) {
        return listService.getColumn(listService.currentPageId, order);
    }

    getCurrentLayout() {
        if(mobileListService.mobileCurrentColumnView === constants.TWO_COLUMN_VIEW_DROPDOWN_TEXT) {
            return mobileConstants.SECOND_COLUMN_ORDER;
        }
        return  mobileConstants.CURRENT_COLUMN_ORDER;
    }

    sectionsLayoutRender(layout) {
        const element1Id = `column1-content`;
        const element2Id = `column2-content`;

        const sectionRender = (elementId, order, layoutColumn) => {
            const sections = layoutColumn.sections;

            if (sections && sections.size) {
                sections
                    .filter(section => listService.getMobileObjectsBySectionId(section.id).size > 0)
                    .forEach(section => {
                        let controlSection = mobileListService.getMobileControl(section.id);
                        controlSection.model.updateSection(section.id);
                        controlSection.model.set('state', this.isHiddenSection(controlSection) ? 'hidden':'default', constants.MODEL_SILENT);
                        controlSection.model.set('container', elementId, constants.MODEL_SILENT);

                        controlSection.render();
                        controlSection.controlsRender();
                });

                const emptyColumnBadge = $(`#${constants.EMPTY_COLUMN_BADGE}`);
                const counterResetBadges = $(`#${constants.COUNTER_RESET_BADGES}`);

                if (order === mobileConstants.CURRENT_COLUMN_ORDER) {
                    $(`#${constants.COLUMN_ONE_COUNTER_ID}`).text(sections.size);
                    emptyColumnBadge.css('display', 'flex');
                    counterResetBadges.css('display', 'none');
                } else if (order === mobileConstants.FIRST_COLUMN_ORDER) {
                    $(`#${constants.COLUMN_ONE_COUNTER_ID}`).text(sections.size);
                } else if (order === mobileConstants.SECOND_COLUMN_ORDER) {
                    $(`#${constants.COLUMN_TWO_COUNTER_ID}`).text(sections.size);
                    emptyColumnBadge.css('display', 'none');
                    counterResetBadges.css('display', 'flex');
                }
            }
            this.afterRenderTriggers();
        };

        const renderTwoColumns = (layoutColumn1, layoutColumn2) => {
            sectionRender(element1Id, mobileConstants.FIRST_COLUMN_ORDER, layoutColumn1);
            sectionRender(element2Id, mobileConstants.SECOND_COLUMN_ORDER, layoutColumn2);
        };

        const renderOneColumn = () => {
            let layoutColumn = this.getLayoutColumnByOrder(mobileConstants.CURRENT_COLUMN_ORDER);
            if (layoutColumn) {
                sectionRender( element1Id, mobileConstants.CURRENT_COLUMN_ORDER, layoutColumn);
            }
        };

        if (layout === mobileConstants.CURRENT_COLUMN_ORDER) {
            renderOneColumn();
        } else if(layout === mobileConstants.SECOND_COLUMN_ORDER){
            let layoutColumn1 = this.getLayoutColumnByOrder(mobileConstants.FIRST_COLUMN_ORDER);
            let layoutColumn2 = this.getLayoutColumnByOrder(mobileConstants.SECOND_COLUMN_ORDER);
            if (layoutColumn1 && layoutColumn1.sections && layoutColumn2 && layoutColumn2.sections) {
                renderTwoColumns(layoutColumn1, layoutColumn2);
            } else {
                renderOneColumn();
            }
        }
    }

    render() {
        this.$el.empty();
        this.$el.html(template(this.model.toJSON()));
        this.setUpWidgets();
        return this;
    }

    afterRenderMobileColumns() {
        $(constants.FORM_ID).css('text-align', 'center');
        $(constants.PAGE_ID).css('display', 'inline-block');
        $(constants.PAGE_ID).css('margin', '0 auto');
        $('#mobile-columns-container').css('background-color', listService.currentForm.model.get('mobileOutsideColor'));
        $('#column2-title').parent().append(badgesTemplate);
        $(`#${constants.COLUMNS_RESET_ID}`).on(constants.EV_CLICK, () => { this.resetColumn(); });
    }

    afterRenderTriggers() {
        eventBus.trigger(mobileConstants.CREATE_DRAGGABLE_SECTION);
        eventBus.trigger(mobileConstants.CREATE_DRAGGABLE_MOBILE_CONTROLS);
    }

}

export default MobileDesignerColumnView;